export interface BudgetCategoryCustomFieldConditionConstructorData {
  fieldId: number
  values: string[]
}

/**
 * A budget's condition on one order item custom field: the budget covers
 * lines whose value for that field is one of `values`. Checkbox values are
 * the stored strings (`'True'` / `'False'`).
 */
export class BudgetCategoryCustomFieldCondition {
  readonly fieldId: number
  readonly values: string[]

  constructor(data: BudgetCategoryCustomFieldConditionConstructorData) {
    this.fieldId = data.fieldId
    this.values = data.values
  }
}
